module.exports = __webpack_public_path__ + "img/refresh_black.b001e5d1.svg";